import { useState, useEffect } from 'react'

export default function useWindowWidth(initialWidth = 0) {
  const [windowWidth, setWindowWidth] = useState(process.browser ? window.innerWidth : initialWidth)

  useEffect(() => {
    const getSize = () => (process.browser ? window.innerWidth : initialWidth)
    const handleResize = () => {
      const newWidth = getSize()
      if (newWidth !== windowWidth) {
        setWindowWidth(newWidth)
      }
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return windowWidth
}
